import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';
import Toast from '../../components/Toast';

export default function Tools() {
  const [tools, setTools] = useState([]);
  const [health, setHealth] = useState({});
  const [toast, setToast] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', url: '', icon: 'tool', category: '', health_check_url: '', sso_enabled: true });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    const [t, h] = await Promise.all([api.get('/tools/all'), api.get('/tools/health').catch(() => [])]);
    setTools(t);
    const hm = {};
    if (Array.isArray(h)) h.forEach(x => { hm[x.tool_id] = x.status; });
    setHealth(hm);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const data = { ...form, health_check_url: form.health_check_url || form.url };
      if (modal === 'new') {
        await api.post('/tools', data);
        setToast({ message: 'Herramienta creada', type: 'success' });
      } else {
        await api.put(`/tools/${modal}`, data);
        setToast({ message: 'Herramienta actualizada', type: 'success' });
      }
      setModal(null);
      loadData();
    } catch (err) {
      setToast({ message: err.message, type: 'error' });
    }
  };

  const toggleActive = async (id, current) => {
    try {
      await api.put(`/tools/${id}`, { is_active: !current });
      loadData();
    } catch (err) {
      setToast({ message: err.message, type: 'error' });
    }
  };

  const openEdit = (tool) => {
    setForm({
      name: tool.name, description: tool.description || '', url: tool.url,
      icon: tool.icon || 'tool', category: tool.category || '',
      health_check_url: tool.health_check_url || '', sso_enabled: tool.sso_enabled,
    });
    setModal(tool.id);
  };

  const statusColor = (id) => {
    const s = health[id];
    return s === 'online' ? '#22c55e' : s === 'offline' ? '#ef4444' : '#d1d5db';
  };

  return (
    <div>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}

      <div className="flex justify-between items-center mb-4">
        <span className="text-sm text-gray-500">{tools.length} herramientas</span>
        <button onClick={() => { setForm({ name: '', description: '', url: '', icon: 'tool', category: '', health_check_url: '', sso_enabled: true }); setModal('new'); }}
          className="btn-accent text-sm px-4 py-2 rounded-lg">
          Nueva herramienta
        </button>
      </div>

      <div className="space-y-3">
        {tools.map(t => (
          <div key={t.id} className="bg-white rounded-xl p-4 shadow-sm flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: statusColor(t.id) }} />
              <div>
                <p className="font-medium">{t.name}</p>
                <p className="text-xs text-gray-400">{t.url}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className={`text-xs px-2 py-0.5 rounded-full ${t.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                {t.is_active ? 'Activa' : 'Inactiva'}
              </span>
              <button onClick={() => openEdit(t)} className="text-xs font-medium hover:underline" style={{ color: '#FFB800' }}>Editar</button>
              <button onClick={() => toggleActive(t.id, t.is_active)} className="text-xs text-gray-400 hover:underline">
                {t.is_active ? 'Desactivar' : 'Activar'}
              </button>
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setModal(null)}>
          <div className="bg-white rounded-xl p-6 w-full max-w-md max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <h3 className="font-bold text-lg mb-4">{modal === 'new' ? 'Nueva herramienta' : 'Editar herramienta'}</h3>
            <form onSubmit={handleSave} className="space-y-3">
              <input type="text" placeholder="Nombre" value={form.name} onChange={e => setForm({...form, name: e.target.value})}
                className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2" required />
              <input type="text" placeholder="Descripción" value={form.description} onChange={e => setForm({...form, description: e.target.value})}
                className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2" />
              <input type="url" placeholder="URL (https://...)" value={form.url} onChange={e => setForm({...form, url: e.target.value})}
                className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2" required />
              <input type="text" placeholder="Categoría" value={form.category} onChange={e => setForm({...form, category: e.target.value})}
                className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2" />
              <select value={form.icon} onChange={e => setForm({...form, icon: e.target.value})}
                className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2">
                {['tool','newspaper','briefcase','chart','layout','search','wallet'].map(i =>
                  <option key={i} value={i}>{i}</option>
                )}
              </select>
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={form.sso_enabled} onChange={e => setForm({...form, sso_enabled: e.target.checked})}
                  className="rounded border-gray-300" />
                SSO habilitado
              </label>
              <div className="flex gap-2 pt-2">
                <button type="submit" className="btn-accent flex-1 py-2.5 rounded-lg text-sm">Guardar</button>
                <button type="button" onClick={() => setModal(null)} className="btn-ghost flex-1 py-2.5 rounded-lg text-sm">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
